import "../css/theme.css";
import { useTheme } from "../OAS365Theme";

export const useViewCopyStyle = () => {
  const theme = useTheme();
  const accordianThemeStyle = {
    accordianStyle: useAccordianStyle(theme),
    accordianTextStyle: useAccordianTextStyle(theme),
    accordianDetails: useAccordianDetails(theme),
    accordianBoxStyle: useAccordionBoxStyle(theme),
    viewCopyTextStyle: useViewCopyTextStyle(theme),
  };
  return accordianThemeStyle;
};
const useAccordianStyle = (theme) => {
  const style = {
    backgroundColor: "#E6F4EA",
    boxShadow: "none",
    border: "1px solid",
    borderColor: theme.colors.viewCopyAccordianBorderColor,
    borderBottomRightRadius: "0px",
    borderBottomLeftRadius: "0px",
    borderTopRightRadius: "0px",
    borderTopLeftRadius: "0px",
  };
  return style;
};

const useAccordianTextStyle = (theme) => {
  const style = {
    fontFamily: theme.fonts.regular,
    fontSize: theme.fontSizes.normal,
    fontWeight: "bold",
    color: "#4c8d6a",
  };
  return style;
};

const useAccordianDetails = (theme) => {
  const style = {
    
      padding: "16px",
      paddingBottom: "6px",
      backgroundColor: theme.colors.backgroundColor,
  };
  return style;
};

const useAccordionBoxStyle = (theme) => {
  const style = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    border: "2px dashed #e1e1e1",
    borderRadius: "0.5rem",
    width: "95%",
    padding: "10px",
    transition: "height 0.3s ease",
  };

  return style;
};

const useViewCopyTextStyle = (theme) => {
  const style = {
    color: theme.colors.fontColor,
    textAlign: "center",
    fontFamily: theme.fonts.regular,
    fontSize: theme.fontSizes.normal,
  };
  return style;
};
